export default __webpack_public_path__ + "static/media/coffre.6921c9a8.png";